import { render, staticRenderFns } from "./After.vue?vue&type=template&id=4146b024&scoped=true"
import script from "./After.vue?vue&type=script&lang=js"
export * from "./After.vue?vue&type=script&lang=js"
import style0 from "./After.vue?vue&type=style&index=0&id=4146b024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4146b024",
  null
  
)

export default component.exports